import { RootState } from '..';

export const selectFloorsData = (state: RootState) => state.localRobot.floors;
export const selectFloorsRestSet = (state: RootState) => state.localRobot.floors.rest;

export const selectRoomsRestSet = (state: RootState) => state.localRobot.rooms.rest;
export const selectSelectedRoomId = (state: RootState) => state.localRobot.rooms.selectedId;

export const selectErrors = (state: RootState) => state.localRobot.errors.data;
export const selectErrorsRestSet = (state: RootState) => state.localRobot.errors.rest;
